import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TimelineEvent = ({ time, label, isAlert }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      <div>
        <Text type="bodyXSRegular" color={theme.colors.grey.tone500}>
          {time}
        </Text>
      </div>
      <Styles.Description>
        {isAlert && <WarningIcon size={16} color={theme.colors.orange.tone500} />}
        <Text type="bodySRegular">{label}</Text>
      </Styles.Description>
    </Styles.Container>
  )
}

export default TimelineEvent
